var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBtnClearMobile = function SvgBtnClearMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ECECF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9391 11.9994L15.803 9.14178C15.9284 9.01635 15.9988 8.84623 15.9988 8.66884C15.9988 8.49145 15.9284 8.32133 15.803 8.1959C15.6775 8.07047 15.5074 8 15.3301 8C15.1527 8 14.9826 8.07047 14.8572 8.1959L12 11.0602L9.14276 8.1959C9.01734 8.07047 8.84724 8 8.66988 8C8.49252 8 8.32242 8.07047 8.19701 8.1959C8.07159 8.32133 8.00114 8.49145 8.00114 8.66884C8.00114 8.84623 8.07159 9.01635 8.19701 9.14178L11.0609 11.9994L8.19701 14.857C8.13458 14.919 8.08503 14.9926 8.05122 15.0738C8.01741 15.155 8 15.2421 8 15.33C8 15.4179 8.01741 15.505 8.05122 15.5862C8.08503 15.6673 8.13458 15.741 8.19701 15.8029C8.25892 15.8654 8.33259 15.9149 8.41375 15.9487C8.49491 15.9826 8.58196 16 8.66988 16C8.7578 16 8.84486 15.9826 8.92602 15.9487C9.00718 15.9149 9.08084 15.8654 9.14276 15.8029L12 12.9386L14.8572 15.8029C14.9191 15.8654 14.9928 15.9149 15.0739 15.9487C15.1551 15.9826 15.2422 16 15.3301 16C15.418 16 15.5051 15.9826 15.5862 15.9487C15.6674 15.9149 15.741 15.8654 15.803 15.8029C15.8654 15.741 15.9149 15.6673 15.9487 15.5862C15.9826 15.505 16 15.4179 16 15.33C16 15.2421 15.9826 15.155 15.9487 15.0738C15.9149 14.9926 15.8654 14.919 15.803 14.857L12.9391 11.9994Z",
    fill: "#5656FC",
    stroke: "#5656FC",
    strokeWidth: 0.155555
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnClearMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btnClearMobile.c0cb6f78.svg";
export { ForwardRef as ReactComponent };